export const post = async (url: string, payload: object) => {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: { Accept: 'application/json' },
    body: JSON.stringify(payload)
  });

  await response.json();
};
